import { RoutePath } from '@core/types/route';

import { LegalLink, LegalLinkRecord } from '../../types/legal-links';

export const LEGAL_LINKS: LegalLinkRecord = {
  [LegalLink.AGB]: { text: 'AGB', url: RoutePath.Agb },
  [LegalLink.Datenschutz]: { text: 'Datenschutz', url: RoutePath.Datenschutz },
  [LegalLink.Impressum]: { text: 'Impressum', url: RoutePath.Impressum },
  [LegalLink.Sitemap]: { text: 'Sitemap', url: RoutePath.Sitemap },
};
